const initialState = {
  current: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case 'FETCH_GUARANTOR':
      state = {
        ...state,
        ...{
          current: action.payload,
        },
      };
      break;

    case 'CLEAR_GUARANTOR':
      state = {
        ...state,
        ...{
          current: {},
        },
      };
      break;

    default:
      break;
  }

  return state;
};
